import { IApplicationContext, TReduxStore } from '../../../../shared/types';
import { IMicrofrontendMethodContext } from '../../../../shared/types/microfrontend';
import { createMicrofrontendUI } from '../createMicrofrontendUI';
import { APIRuntimeBuilder, exportsModule } from '@cian/mf-registry/browser';
import { buyPackageHandler, buyCustomPackageHandler, prolongSubscriptionHandler } from './handlers';

export const initMicrofrontend = (context: IApplicationContext, store: TReduxStore) => {
  const apiContext: IMicrofrontendMethodContext = { store };

  exportsModule({
    ui: {
      '/v1/get-microfrontend/': createMicrofrontendUI({ context, store }),
    },
    api: () =>
      [
        {
          path: '/v1/buy-package/',
          handler: buyPackageHandler(apiContext),
        },
        {
          path: '/v2/buy-custom-package/',
          handler: buyCustomPackageHandler(apiContext),
        },
        {
          path: '/v1/prolong-subscription/',
          handler: prolongSubscriptionHandler(apiContext),
        },
      ] as APIRuntimeBuilder,
  });
};
